import React from "react"
import Link from "next/link"
import {CaretRightFill} from "react-bootstrap-icons"
import {useTranslation} from "next-i18next"
import Typography from "../reusable/Typography/Typography"
import Image from "next/image"

const ConsultationHeader = () => {
	const {t} = useTranslation("consultationPage")
	return (
		<div className="position-relative d-md-none">
			<div className="container-lg">
				<div style={{zIndex: 1}}
					className="common-header text-black-md-white mt-3 mt-md-2">
					<div className={"row"}>
						<div className={"mt-2 mb-2"}>
							<Link href={"/"}>
								<a className="text-decoration-none">
									<Typography variant="bodySm"
										semanticTag="span"
										className="pointer text-black-md-white">{t("Home")}</Typography>
								</a>
							</Link>
							<CaretRightFill className={"ms-2 me-2"}
								size={10}/>
							<Typography variant="bodySmBold"
								semanticTag="span" >{"E-Bike Wiki"}</Typography>
						</div>
					</div>
				</div>
			</div>
			<div className="d-flex justify-content-center justify-content-md-start col-12 bg-danger container-lg">
				<Typography style={{fontWeight: 700}}
					className="header-banner-title text-center col-7 col-md-8 col-xl-4 w-md-100 text-md-start position-absolute text-white "
					variant="heading1"
					semanticTag="h1">{t("E-Bike Consultation").toUpperCase()}</Typography>
			</div>
			<div className="header-banner-img position-relative">
				<Image src="/assets/images/consultation-page/main-v2.jpg"
					alt="consult-main"
					layout="fill"
					objectFit="cover"/>
			</div>
		</div>
	)
}

export default ConsultationHeader
